import React, { useContext, useEffect, useState } from "react";

import Divider from "../../shared/components/divider/divider";
import ShIcon from "../../shared/components/sh-icon/sh-icon";
import ShLink from "../../shared/components/sh-link/sh-link";
import { Media } from "../../shared/contexts/media/MediaContext";
import { UiStateContext } from "../../shared/contexts/ui-state/UiStateContext";
import { IconPack, Icon, MegaMenuColumnContent, MegaMenuColumnModel, FeatureToggle } from "../../shared/models/app-data-model";
import "./mega-menu-column.scss";

export type MegaMenuColumnProps = {
  content: MegaMenuColumnModel;
  iconPack?: IconPack[];
  featureToggles: FeatureToggle[];
  columnNumber: number;
};

const MegaMenuColumn: React.FC<MegaMenuColumnProps> = ({ content, iconPack, featureToggles, columnNumber }: MegaMenuColumnProps) => {
  const iconMock = (item: MegaMenuColumnContent) => {
    return {
      svg: {
        content_type: "image/svg+xml",
        localAsset: item.icon_link.icon.icon_source.localAsset,
        title: item.icon_link.icon.icon_alt_text,
        url: item.icon_link.icon.icon_source.url
      }
    } as Icon;
  };

  return (
    <div className={`mm-column mm-column-${columnNumber}`}>
      <Media lessThan="desktop">
        <div className={`mega-column-heading mm-header-${columnNumber}`}>{content.column_heading}</div>
      </Media>

      {content?.column_contents?.map((item, index) => {
        return (
          <>
            {item.image_with_background && item.image_with_background.image && (
              <Media greaterThanOrEqual="tablet">
                <div className="mm-img-container" key={index}>
                  <div className={`mm-img-background ${item.image_with_background.image_background_color}-background`}>
                    <img className="mm-image" alt={item.image_with_background.image_alt_text} src={item.image_with_background.image.url} />
                  </div>
                  {item.image_with_background.image_description && (
                    <p className="mm-img-description">{item.image_with_background.image_description}</p>
                  )}
                </div>
              </Media>
            )}
            {item.icon_link && item.icon_link.link_reference && (
              <>
                <div className="mm-icon-link-container" key={index}>
                  <ShLink
                    className="mm-icon-link"
                    featureToggles={featureToggles}
                    reference={item.icon_link.link_reference}
                    iconPack={iconPack}
                    regionalLinkAsButton={true}
                    closeMenus={true}
                  >
                    {item.icon_link.icon ? <ShIcon className="mm-link-icon" icon={iconMock(item)} /> : null}
                    {item.icon_link.link_text}
                  </ShLink>
                  {item.icon_link.link_description ? <p className="mm-icon-link-description">{item.icon_link.link_description}</p> : null}
                </div>
                <Media lessThan="tablet">
                  {columnNumber !== 4 && index === content?.column_contents?.length - 1 && (
                    <Divider className="divider mm-mobile-divider" />
                  )}
                </Media>
              </>
            )}
            {item.simple_link && item.simple_link.link_reference && (
              <>
                <div className="mm-simple-link-container" key={index}>
                  <ShLink
                    className={item.simple_link.treat_as_tertiary ? "mm-simple-link-tertiary" : "mm-simple-link"}
                    featureToggles={featureToggles}
                    reference={item.simple_link.link_reference}
                    iconPack={iconPack}
                    regionalLinkAsButton={true}
                    closeMenus={true}
                  >
                    {item.simple_link.link_text}
                    {item.simple_link.treat_as_tertiary ? (
                      <ShIcon iconPack={iconPack} iconName="button_arrow" className="icon mm-button-arrow-icon" />
                    ) : null}
                  </ShLink>
                </div>
                <Media lessThan="tablet">
                  {columnNumber !== 4 && index === content?.column_contents?.length - 1 && (
                    <Divider className="divider mm-mobile-divider" />
                  )}
                </Media>
              </>
            )}
          </>
        );
      })}
    </div>
  );
};

export default MegaMenuColumn;
